/**
 * @fileoverview Generic text matching theme for numbers, letters, or any text labels.
 */

import { ThemeOptions } from '../../services/ThemeService.js';
import { ColorConfig, KonvaNode } from './BaseTheme.js';
import { ShapeHelpers } from '../ShapeHelpers.js';
import { TextMatchingTheme } from './TextMatchingTheme.js';

/**
 * Generic text matching theme with colored circle borders.
 * Used for numbers, letters, or any text-based matching.
 */
export abstract class TextCircledMatchingTheme extends TextMatchingTheme {

    constructor(id: string, name: string, labels: Array<string | number>, options: ThemeOptions = {}) {
        super(id, name, labels, options);
    }
    
    createShape(x: number, y: number, size: number, color: ColorConfig, _isDraggable: boolean, label?: string | number): KonvaNode {
        const displayLabel = String(label || this.labels[0]);
        return ShapeHelpers.createTextWithCircleBorder(x, y, size, color, displayLabel);
    }
}
